<template>
  <div class="text-editor-file-widget">
    <TirPmFilePreview
      :file="previewFile"
      :files="previewFiles"
      :variant="FilePreviewVariantEnum.Small"
      :no-media-variant="FilePreviewVariantEnum.Inline"
      :files-loading-edit-name="filesLoadingEditName"
      @on-click-delete="emit('onClickDeleteFile')"
      @on-click-edit="emit('onClickEditFile', $event)"
      @save-name="emitSaveName"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  TirPmFilePreview,
  FilePreviewVariantEnum,
  IFilePreview,
} from "tir-pm-file-preview";
import { computed, PropType } from "vue";
import { ITextEditorFile } from "../interfaces";

const emit = defineEmits<{
  /**Событие клика по кнопке удаления файла*/
  (e: "onClickDeleteFile"): void;
  /**Событие клика по кнопке редактирования файла */
  (e: "onClickEditFile", fileId: string | number): void;
  /**Событие сохранения названия файла */
  (e: "saveName", fileId: string | number, fileName: string): void;
}>();

const emitSaveName = (fileId: string | number, fileName: string) =>
  emit("saveName", fileId, fileName);

const props = defineProps({
  /**Файл */
  file: {
    type: Object as PropType<ITextEditorFile>,
    required: true,
  },
  /**Список файлов */
  files: {
    type: Array as PropType<Array<ITextEditorFile>>,
    default: [],
  },
  /**Загрузка при редактировании названия файла */
  filesLoadingEditName: {
    type: Array as PropType<Array<string | number>>,
    default: [],
  },
});

const convertFile = (file: ITextEditorFile): IFilePreview => {
  const user = file.User;

  return {
    FileId: file.FileId,
    Url: file.Url,
    VideoPreviewUrl: file.VideoPreviewUrl,
    Name: file.Name,
    Size: file.Size,
    DateUpload: file.DateUpload,
    User: user && {
      Id: user.Id,
      FirstName: user.FirstName,
      LastName: user.LastName,
      MiddleName: user.MiddleName,
      AvatarColor: user.AvatarColor,
      Image: user.Image,
    },
    Accesses: file.Accesses,
    Progress: file.Progress,
    IsProccessing: file.IsProccessing,
  };
};

const previewFile = computed(() => convertFile(props.file));
const previewFiles = computed(() => props.files.map(convertFile));
</script>

<style lang="scss" scoped>
.text-editor-file-widget {
  display: inline-flex;
  padding: 0 0.25rem;

  &__inline {
    display: flex;
    align-items: center;
    gap: 0.125rem;
    color: var(--IconPickerContent-Violet1, #9d12de);
    border-radius: var(--4, 0.25rem);
    background: var(--IconPickerBackground-Violet1, rgba(157, 18, 222, 0.1));
    border: var(--0, 1px) solid var(--IconPickerContent-Violet1, #9d12de);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    padding: 0 0.25rem;
  }
  &__inline-icon {
    width: 1rem;
    height: 1rem;
  }
  &__inline-icon,
  &__inline-ext {
    flex-shrink: 0;
  }
  &__inline-name {
    display: block;
    max-width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
